<c-card *transloco="let t">
    <c-card-body class="px-2">
  
        <c-row>
            <c-col class="col-lg-6 col-12">
                <img alt="Safety Monitoring center" src="../../../assets/images/live-monitoring-image1.jpg"   class="img-fluid mb-3"/>

                <h1>Safety Monitoring Center</h1>
                <h2>Get Immediate 24/7 Emergency Help, Faster Than 911.</h2>
                <h4>Protect your people 24/7 with an Enhanced 24/7 Monitoring service that delivers:</h4>
                <ul>
                <li>Immediate emergency help directly to your pinpoint location, across US & Canada.</li>
                <li>Professionally trained agents who know how to react quickly and calmly in a crisis.</li>
                <li>Customized help based on your unique escalation plans.</li>
                </ul>

                <img alt="Safety Monitoring Center" src="../../../assets/images/live-monitoring-incident-response.jpg"   class="img-fluid"/> <br/><br/>

                <div class="text-center">
                    <a class="btn btn-outline-success" href="https://www.okaloneworker.com/safety-monitoring-centre/" role="button">Learn more about Enhanced 24/7 Monitoring</a>
                </div>

            </c-col>
          <c-col class="col-lg-6 col-12">
            <div class="card mb-3" *ngIf="!okService.settings.arc_on">

                <div class="card-header">
                    <h4>Want to use our Safety Monitoring Center with 24/7 Enhanced Monitoring?</h4>
                </div>
                <div class="card-body">
                    Our Enhanced 24/7 Monitoring is now available. If you want to learn how you can add this to your OK Alone service then please email us at 
                    <a href="sales@ok-alone.com">sales&#64;ok-alone.com</a>.
                </div>
            </div>

            <ng-container *ngIf="!okService.settings.arc_on" class="mt-3">
                <h3 class="orange-title-1">Safety Monitoring Center Benefits</h3>
                <h4>24/7 Emergency service response</h4><p>Whether facing medical emergencies, accidents, or unforeseen incidents, knowing help is available around the clock can be a lifesaver.</p>
                <hr/>
                <h4>Fully trained professsionals</h4><p>Engaging with trained professionals ensures a top-level service. This boosts safety for lone workers and fosters confidence in our services.</p>
                <hr/>
                <h4>Quicker help than calling 911</h4><p>Our safety monitoring app offers faster assistance than dialing 911. This saves critical time during emergencies.</p>
                <hr/>
                <h4>Guaranteed response</h4><p>SOS Alarms are responded to immediately, removing the need for your managers to be available 24/7 to receive emergency alerts.</p>
                <hr/>
                <h4>No reliance on your team</h4><p>Our professionals will handle emergency alarms, so that your team don’t need to be on high-alert 24/7.</p>
                <hr/>
                <h4>Incident report management</h4><p>All calls are recorded and available in our portal, giving you everything you need to effectively report on incidents.</p>
            </ng-container>

            <div class="card" *ngIf="okService.settings.arc_on">
                <div class="card-header">
                  <h4>Your Latest Safety Monitoring Center Alerts</h4>
                </div>
                <div class="card-body">
                    
          <c-row *ngIf="alerts">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ t('Status') }}</th>
                    <th scope="col">{{ t('Alert') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let alert of alerts">
                      <td>
                        <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/reports/alert/{{alert.id}}">
                          <i class="fa-solid fa-eye"></i> {{ t('View') }}
                        </button>
                      </td>
                      <td>
                        <i class="fa-solid fa-circle-check fa-3x text-success" *ngIf="alert.resolved"></i>
                        <i class="fa-solid fa-triangle-exclamation fa-3x text-warning" *ngIf="!alert.resolved"></i>
                      </td>
                      <td>
                        <span class="fs-5">{{alert.title}}</span>
                      </td>
                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>

          <br/>

          <button class="btn btn-outline-secondary" type="button" routerLink="/reports/alerts">{{ t('View all Alerts') }}</button>
                      
                </div>
              </div>


          </c-col>
        </c-row>

    </c-card-body>
</c-card>